interface PriceWithDiscountProps {
  originalPrice: number;
  discountPrice: number;
  className?: string;
}

const PriceWithDiscount = ({
  originalPrice,
  discountPrice,
  className = '',
}: PriceWithDiscountProps) => {
  const hasDiscount = (discountPrice ?? 0) < originalPrice;

  return (
    <div className={`flex flex-col items-end gap-1 ${className}`}>
      {/* Discounted price */}
      <div className="flex items-center gap-1">
        <span className="font-bold text-gray-700 text-md">
          {discountPrice.toLocaleString()}
        </span>

        <span className="text-sm text-gray-500">تومان</span>
      </div>

      {/* Original price */}
      {hasDiscount && (
        <div className="relative inline-flex items-center opacity-40">
          <span className="text-sm font-medium text-gray-700">
            {originalPrice.toLocaleString()} تومان
          </span>

          {/* Crooked red line */}
          <span className="absolute left-[-4px] top-1/2 h-[2px] w-[110%] rotate-[-12deg] bg-red-500 rounded-full" />
        </div>
      )}
    </div>
  );
};

export default PriceWithDiscount;
